import { App, DirectiveBinding } from 'vue';

// Объявление расширенного интерфейса для HTMLElement с пользовательским свойством
interface HTMLElementWithClickOutsideEvent extends HTMLElement {
  clickOutsideEvent: (event: Event) => void;
}

const ClickOutsideDirective = {
  beforeMount(el: HTMLElementWithClickOutsideEvent, binding: DirectiveBinding) {
    // Обработчик события клика вне элемента
    el.clickOutsideEvent = function (event: Event) {
      // Проверяем, находится ли событие внутри элемента или его потомков
      const insideElement = el.contains(event.target as Node);

      if (!insideElement) {
        // Если событие не внутри элемента, вызываем переданную функцию
        binding.value(event);
      }
    };
    // Добавка обработчик события клика к глобальному объекту document
    document.addEventListener('click', el.clickOutsideEvent, { capture: true });
  },
  unmounted(el: HTMLElementWithClickOutsideEvent) {
    // Удаление обработчик события клика из глобального объекта document
    document.removeEventListener('click', el.clickOutsideEvent, { capture: true });
  }
};

// Плагин для установки директивы как глобальной директивы в приложении Vue
export const clickOutside = {
  // Метод install, который будет вызван при установке плагина
  install(app: App) {
    // Регистриация директивы с именем 'click-outside' в качестве глобальной директивы
    app.directive('click-outside', ClickOutsideDirective);
  }
};